import React from 'react';

import { useRouter } from 'react-resource-router';

import { getConfig } from '../../config';
import { useAtlassianUserContext } from '../../hooks/use-atlassian-user';
import { NoAppsAvailablePage } from '../components/NoAppsAvailablePage';

type ExternalUserRouteGateProps = {
	children: React.ReactNode;
};

const QUERY_BUILDER_ROUTE_PREFIX = '/query-builder';

export const ExternalUserRouteGate = ({
	children,
}: ExternalUserRouteGateProps): React.JSX.Element | null => {
	const [{ route }] = useRouter();
	const { identity, loading } = useAtlassianUserContext();
	const isLocalDevelopment = getConfig().isLocalDev;
	const isQueryBuilderRoute =
		route.path === QUERY_BUILDER_ROUTE_PREFIX ||
		route.path.startsWith(`${QUERY_BUILDER_ROUTE_PREFIX}/`);
	const isHomeRoute = route.path === '/';
	const shouldRedirectHomeToQueryBuilder = isHomeRoute && !identity.isAtlassianEmployee;

	React.useEffect(() => {
		if (loading || !shouldRedirectHomeToQueryBuilder) {
			return;
		}

		globalThis.history.replaceState(null, '', QUERY_BUILDER_ROUTE_PREFIX);
		globalThis.dispatchEvent(new PopStateEvent('popstate'));
	}, [loading, shouldRedirectHomeToQueryBuilder]);

	if (loading || shouldRedirectHomeToQueryBuilder) {
		return null;
	}

	if (
		!isLocalDevelopment &&
		!identity.isAtlassianEmployee &&
		!isHomeRoute &&
		!isQueryBuilderRoute
	) {
		return <NoAppsAvailablePage />;
	}

	return <>{children}</>;
};
